const generateArray = (num: number): number[] => Array.from(Array(num).keys());

export default generateArray;
